import http from '@/core/http';
import type {
  ICssCustomerInfoReq,
  ICssCustomerInfoRes,
  IDemandSkcPageListItem,
  IDemandSkcPageReq,
  IProdDemandPageListItem,
  IProdDemandPageReq,
  IProductionOrderListReq,
  IProductionOrderListRes,
  IProductionOrderLogsRes,
  IProductionOrderUpdateReq,
  IPurchaserDetailRes,
  IPurchaserListReq,
  IPurchaserListRes,
  IV1ProdDemandReq,
  IV1ProdDemandRes,
  IV1ProductionOrderRes,
} from './type';

/**
 * 订单列表
 * https://yapi.ibaibu.com/project/1386/interface/api/109846
 */
export function getOrderList(data: IProductionOrderListReq) {
  return http.post<IProductionOrderListRes>({
    url: '/plm-demand/ops/v1/production-order/list',
    data,
    isCancelDuplicateUrlRequests: true,
  });
}

/**
 * 订单详情
 */
export function getOrderDetail(orderId: string) {
  return http.get<IV1ProductionOrderRes>({
    url: `/plm-demand/ops/v1/production-order/${orderId}`,
    loading: true,
  });
}

/**
 * 更新订单
 */
export function updateOrder(data: IProductionOrderUpdateReq) {
  return http.post({
    url: '/plm-demand/ops/v1/production-order/update',
    data,
    loading: true,
  });
}

/**
 * 操作日志
 */
export function getLogDetail(orderId: string) {
  return http.get<IProductionOrderLogsRes>({
    url: `/plm-demand/ops/v1/production-order/logs/${orderId}`,
    loading: true,
  });
}

// skc列表
export const getDemandSkc = (data: IDemandSkcPageReq) => {
  return http.post<IDemandSkcPageListItem[]>({
    url: '/plm-demand/web/v1/demand-skc/page',
    data,
    loading: true,
  });
};

/**
 * 生产需求列表
 * https://yapi.ibaibu.com/project/1386/interface/api/110488
 * @param data
 * @returns
 */
export const getProductionDemandList = (data: IProdDemandPageReq) => {
  return http.post<IProdDemandPageListItem[]>({
    url: '/plm-demand/ops/v1/prod-demand/page',
    data,
    isCancelDuplicateUrlRequests: true,
  });
};
// 生产需求详情
export const getProductionDemandDetail = (demandDetailId: string) => {
  return http.get<IV1ProdDemandRes>({
    url: `/plm-demand/ops/v1/prod-demand/${demandDetailId}`,
    loading: true,
  });
};
// 编辑生产需求
export const updateProductionDemand = (data: IV1ProdDemandReq) => {
  return http.put({
    url: '/plm-demand/ops/v1/prod-demand',
    data,
    loading: true,
  });
};
// 编辑生产需求
export const getProductionLog = (demandDetailId: string) => {
  return http.get({
    url: `/plm-demand/ops/v1/prod-demand/log/${demandDetailId}`,
    loading: true,
  });
};

// 获取客户授信信息
export const getCustomerCreditInfo = (data: ICssCustomerInfoReq) => {
  const url = '/plm-demand/web/v1/ccs/customer-info';
  return http.post<ICssCustomerInfoRes>({
    url,
    data,
  });
};

// 获取客户详情
export const getCustomerDetail = (purchaserId: string) => {
  return http.get<IPurchaserDetailRes>({
    // url: `/purchaser/web/purchaser/detail/${purchaserId}`,
    url: `/crm-customer/web/purchaser/detail/${purchaserId}`,
  });
};

// 根据 采购商 编码/名称 查询采购商 (crm私海采购商)
// export const getPurchaserByNameCode = (data: ISearchPurchaserPrivateChooseResReq) => {
//   const url = '/purchaser/web/purchaser/search/purchaserPrivateChooseRes';
//   return http.post<ISearchPurchaserPrivateChooseResRes>({
//     url,
//     data,
//   });
// };

/**
 * 采购商查询 - 对接crm
 * @param data
 * @returns
 */
export const getPurchaserByNameCodeCommon = (data: IPurchaserListReq) => {
  // const url = '/purchaser/web/purchaser/list';
  const url = '/crm-customer/web/purchaser/list';
  return http.post<IPurchaserListRes>({
    url,
    data,
  });
};
